import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a5ffe3a1-9427-4b11-b846-936d1780eef8",
    content: "Pure signal at one frequency",
    options: {},
  },
  {
    id: "a6399a15-f4ab-4fd6-9fc9-c2622b75e3f4",
    content: "Dirac δ",
    options: {},
  },
  {
    id: "9d9b8abf-f2a2-4788-8273-6b77c897a5d2",
    content: "Rectangular window",
    options: {},
  },
  {
    id: "220a9d90-61b9-41ee-a2fb-8591335255f7",
    content: "None of them",
    options: {},
  },
];

export const task: Task = {
  id: "58bd38f2-5ddc-4a12-b0a2-f60bd49959dd",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["9d9b8abf-f2a2-4788-8273-6b77c897a5d2"],
};
